import React, { useEffect, useRef, useState } from 'react'
import {
  StyledTimeDisplay,
  StyledProgressBar,
  StyledProgressBarWrapper,
} from './PlayerProgressBar.style'
import { roundToPrecision, toTimeFormat, formatTimeOutput } from '../../../../utils'

export interface Props {
  currentTime: number
  duration: number
  videoRef: React.RefObject<HTMLVideoElement>
  setCurrentTime: React.Dispatch<React.SetStateAction<number>>
  setIsPlaying: React.Dispatch<React.SetStateAction<boolean>>
  isPlaying: boolean
}

const PlayerProgressBar = ({ currentTime, duration, videoRef }: Props): JSX.Element => {
  const [progress, setProgress] = useState<number>(0)
  const [isDragging, setIsDragging] = useState<boolean>(false)
  const progressBarRef = useRef<HTMLInputElement | null>(null)

  const handleSliderChange = (e): void => {
    const newProgress = parseFloat(e.target.value)
    setProgress(newProgress)
    if (videoRef.current) {
      videoRef.current.currentTime = (newProgress / 100) * videoRef.current.duration
    }
  }

  useEffect(() => {
    const handleTimeUpdate = (): void => {
      if (videoRef.current && !isDragging) {
        const newProgress = (videoRef.current.currentTime / videoRef.current.duration) * 100
        setProgress(isNaN(newProgress) ? 0 : newProgress)
      }
    }

    handleTimeUpdate()
  }, [videoRef, currentTime, isDragging])

  const handleMouseDown = (): void => {
    setIsDragging(true)
  }

  const handleMouseUp = (): void => {
    setIsDragging(false)
  }

  return (
    <StyledProgressBarWrapper>
      <StyledProgressBar
        type="range"
        ref={progressBarRef}
        min="0"
        max="100"
        step="0.1"
        value={progress}
        onChange={handleSliderChange}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
        style={{ width: '100%' }}
      />
      <StyledTimeDisplay>
        {formatTimeOutput(toTimeFormat(roundToPrecision(currentTime)))} /{' '}
        {formatTimeOutput(toTimeFormat(roundToPrecision(duration)))}
      </StyledTimeDisplay>
    </StyledProgressBarWrapper>
  )
}

export default PlayerProgressBar
